const fonts = {
    custom: {
        families: [
            'Arial:n4,n7',
            'Arial Narrow:n4,n7',
            'Asterisk:n4',
            'Burbank Big Regular:n7',
            'Burbank Small:n4,n7',
            'CCComiccrazy:n4,n7,i7',
            'CCFaceFront:n4,i7',
            'CPLCD:n4'
        ],
        urls: [
            'assets/styles/fonts.css'
        ]
    }
}

export default fonts
